import { useAtomValue, useSetAtom } from "jotai";

import BottomDrawer from "components/BottomDrawer";
import Button from "components/Button";
import DamagedPartsEstimate from "components/DamagedPartsEstimate";
import Feedback from "components/Feedback";
import Flex from "components/Flex";
import Image from "components/Image";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { clientConfigAtom } from "atoms/clientConfig";
import { estimateAtom, estimateTotalAtom } from "atoms/estimate";
import { pageDrawerAtom } from "atoms/pageDrawer";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useEventTracking } from "hooks/useEventTracking";
import { payeeFinalisedAtom } from "atoms/payeeFinalised";
import { useEffect } from "react";

export const PaymentAccepted = () => {
  const { speedyPayment, blockReturnToEstimate = false } = useAtomValue(clientConfigAtom);

  const toggleDrawer = useSetAtom(pageDrawerAtom);
  const { trackEvent } = useEventTracking();
  const { t } = useClientTranslation();
  const estimate = useAtomValue(estimateAtom);
  const estimateTotal = useAtomValue(estimateTotalAtom);
  const setPayeeFinalised = useSetAtom(payeeFinalisedAtom);
  // Flag payee journey finalised
  useEffect(() => {
    setPayeeFinalised(true);
  }, [setPayeeFinalised]);
  const toggleEstimate = () => {
    toggleDrawer();
    trackEvent({ name: "View initial repair estimate" });
  };

  return (
    <PageLayout contentSpacing="space-between" dataTestId="paymentAccepted">
      <Feedback>
        <Flex mb={36} align="center">
          <Image
            src="/assets/svg/speedy-payment-accepted.svg"
            alt="Speedy payment offer accepted illustration"
            overrides={speedyPayment?.paymentAccepted?.illustrations?.main}
          />

          <Flex mx={40} align="center">
            <Text as="h1" sizeVariant="xl" weight={500} mb={8} align="center">
              {t("offer_accepted.header")}
            </Text>
            <Text sizeVariant="xxxl" weight={500} mb={24}>
              {estimateTotal}
            </Text>
            <Text sizeVariant="md" mb={36} align="center">
              {t("offer_accepted.instruction")}
            </Text>
            {!blockReturnToEstimate && (
              <Button typeVariant="link" style={{ textDecoration: "none", fontWeight: 600 }} onClick={toggleEstimate}>
                {t("global.view_initial_repair_estimate")}
              </Button>
            )}
          </Flex>
        </Flex>
      </Feedback>
      {estimate && (
        <BottomDrawer heading={t("global.view_initial_repair_estimate")} stickyBoxShadow={true}>
          <DamagedPartsEstimate estimate={estimate} />
        </BottomDrawer>
      )}
    </PageLayout>
  );
};
